import { INSIDER_MEMBERSHIP_PAUSE_ENABLED } from "@faire/web-api/indigofair/settings/INSIDER_MEMBERSHIP_PAUSE_ENABLED";

import { useSetting } from "@faire/retailer/settings/__internal__/useSetting";

export const useSettingInsiderMembershipPauseEnabled = (): boolean =>
  useSetting(INSIDER_MEMBERSHIP_PAUSE_ENABLED, true);
